export default {
  GeneralFormat: 0,
  ReadAmount: 1,
};
